import { StyleSheet } from 'react-native';

import { isWebPlatform } from '../../../boot/utils';
import {
  coral,
  neutralDark,
  neutralGrey,
  peacock,
  statusSuccess,
  warrior,
} from '../../../constants/color';

const styles: any = StyleSheet.create({
  flexCol: {
    flexDirection: 'column',
  },
  flexRow: {
    flexDirection: 'row',
  },
  container: {
    marginHorizontal: 15,
  },
  paymentSection: {
    flex: 1,
    paddingVertical: 15,
    flexDirection: 'column',
    position: 'relative',
  },
  dataField: {
    marginRight: 5,
  },
  lightGray: {
    color: neutralDark,
  },
  dataKeyText: {
    lineHeight: 21,
    justifyContent: 'center',
    fontSize: 15,
    color: neutralDark,
  },
  separator: {
    flex: 1,
    marginVertical: 7,
    borderBottomWidth: 0.5,
    borderBottomColor: neutralGrey,
    height: 1,
  },
  dataValueLayout: {
    flex: 1,
    justifyContent: 'center',
  },
  dataValueText: {
    fontSize: 15,
    lineHeight: 21,
    color: warrior,
  },
  dataValueHint: {
    fontSize: 14,
  },
  dateValueText: {
    color: coral,
    paddingBottom: 5,
  },
  accountTips: {
    fontSize: 15,
    color: neutralDark,
    lineHeight: 22,
  },
  limitHint: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 5,
    borderColor: 'transparent',
    borderWidth: 1,
  },
  limitHintText: {
    marginLeft: 3,
    fontSize: 13,
    lineHeight: 17,
    color: peacock,
    flex: 1,
  },
  creditMsg: {
    flex: 1,
    marginTop: 5,
    marginBottom: isWebPlatform ? 5 : 0,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  creditMsgText: {
    flex: 1,
    fontSize: 15,
    lineHeight: 21,
    marginLeft: 3,
  },
  creditSuccess: {
    color: statusSuccess,
  },
  creditFailure: {
    color: coral,
  },
  withShadow: {
    shadowColor: neutralGrey,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.4,
    shadowRadius: 2,
  },
});

export default styles;
